import Vue from 'vue'
import Router from 'vue-router'
import Bus from './views/BusManagement/Bus.vue'
import AddBus from './views/BusManagement/AddBus.vue'
import Login from './views/Login.vue'
import Forgot from './views/Forgot.vue'
import DetailBus from './views/BusManagement/DetailBus.vue'
import EditBus from './views/BusManagement/EditBus.vue'
import ParentList from './views/ParentManagement/ParentList.vue'
import AddParent from './views/ParentManagement/AddParent.vue'
import DetailParent from './views/ParentManagement/DetailParent.vue'
import EditParent from './views/ParentManagement/EditParent.vue'
import AddDriver from './views/Driver/AddDriver.vue'
import ListDriver from './views/Driver/List.vue'
import AddSubDriver from './views/SubDriver/AddSubDriver.vue'
import ListSubDriver from './views/SubDriver/ListSubDriver.vue'
import DetailSubDriver from './views/SubDriver/DetailSubDriver.vue'
import EditSubDriver from './views/SubDriver/EditSubDriver.vue'
import AddPlace from './views/Place/AddPlace.vue'
import ListPlace from './views/Place/ListPlace.vue'
import DetailPlace from './views/Place/DetailPlace.vue'
import EditPlace from "./views/Place/EditPlace.vue";
import ListStudent from "./views/Student/List.vue";
import DetailStudent from "./views/Student/Detail.vue";
import AddPickupRoute from "./views/PickupRoute/Add.vue";
import ListPickupRoute from "./views/PickupRoute/List.vue";
import DetailPickupRoute from "./views/PickupRoute/Detail.vue";
import EditPickupRoute from "./views/PickupRoute/Edit.vue";
import AddDropRoute from "./views/DropRoute/Add.vue";
import ListDropRoute from "./views/DropRoute/List.vue";
import DetailDropRoute from "./views/DropRoute/Detail.vue";
import EditDropRoute from "./views/DropRoute/Edit.vue";
import ConfirmAccount from "./views/ConfirmAccount.vue";
// import UpdateScheduleDropRoute from "./views/DropRoute/UpdateSchedule.vue";
import CreateGrade from './views/GradeManagement/edit'
import EditGrade from './views/GradeManagement/edit'
import DetailGrade from './views/GradeManagement/_id'
import ListGrade from './views/GradeManagement/index'

import ListTermOfUser from './views/TermOfUser'

import AddClass from "./views/ClassManagement/Add.vue";
import ListClass from "./views/ClassManagement/List.vue";
import DetailClass from "./views/ClassManagement/Detail.vue";
import EditClass from "./views/ClassManagement/Edit.vue";
import Samco34 from "./views/BusLayout/Samco34.vue";
import Samco24 from "./views/BusLayout/Samco24.vue";
import Transit16 from "./views/BusLayout/Transit16.vue";
import AddAdminNotificationTemplate from "./views/AdminNotificationTemplate/Add.vue";
import ListAdminNotificationTemplate from "./views/AdminNotificationTemplate/List.vue";
import DetailAdminNotificationTemplate from "./views/AdminNotificationTemplate/Detail.vue";
import EditAdminNotificationTemplate from "./views/AdminNotificationTemplate/Edit.vue";
import AddParentNotificationTemplate from "./views/ParentNotificationTemplate/Add.vue";
import ListParentNotificationTemplate from "./views/ParentNotificationTemplate/List.vue";
import DetailParentNotificationTemplate from "./views/ParentNotificationTemplate/Detail.vue";
import EditParentNotificationTemplate from "./views/ParentNotificationTemplate/Edit.vue";
import AddBusNotificationCategory from "./views/BusNotificationTemplate/AddCategory.vue";
import ListBusNotificationCategory from "./views/BusNotificationTemplate/ListCategory.vue";
import EditBusNotificationCategory from "./views/BusNotificationTemplate/EditCategory.vue";
import DetailBusNotificationCategory from "./views/BusNotificationTemplate/DetailCategory.vue";
import ListBusNotificationTemplate from "./views/BusNotificationTemplate/List.vue";
import AddBusNotificationTemplate from "./views/BusNotificationTemplate/Add.vue";
import DetailBusNotificationTemplate from "./views/BusNotificationTemplate/Detail.vue";
import EditBusNotificationTemplate from "./views/BusNotificationTemplate/Edit.vue";
import AddAdminNotificationGroup from "./views/AdminNotificationGroup/Add.vue";
import ListAdminNotificationGroup from "./views/AdminNotificationGroup/List.vue";
import DetailAdminNotificationGroup from "./views/AdminNotificationGroup/Detail.vue";
import EditAdminNotificationGroup from "./views/AdminNotificationGroup/Edit.vue";
import AddAdminNotification from "./views/Notification/Add.vue";
import ListAdminNotification from "./views/Notification/AdminList.vue";
import DetailAdminNotification from "./views/Notification/AdminDetail.vue";
import ListBusNotification from './views/Notification/BusList.vue'
import DetailBusNotification from "./views/Notification/BusDetail.vue";
import ParentUpdateProfileList from './views/Notification/ParentUpdateProfileList.vue'
import ParentUpdateProfileDetail from './views/Notification/ParentUpdateProfileDetail.vue'
import ParentNotificationList from './views/Notification/ParentList.vue'
import ParentNotificationDetail from './views/Notification/ParentDetail.vue'
import ScheduleDetail from "./views/Schedule/Detail.vue";
import DetailDriver from "./views/Driver/Detail.vue";
import EditDriver from "./views/Driver/Edit.vue";
import SettingSchoolInfo from "./views/SettingSchoolInfo/SettingSchoolInfo.vue";
import AddAdmin from "./views/Admin/Add.vue";
import ListAdmin from "./views/Admin/List.vue";
import DetailAdmin from "./views/Admin/Detail.vue";
import EditAdmin from "./views/Admin/Edit.vue";
import AddAttachment from "./views/AttachmentFileManagement/Add.vue";
import ListAttachment from "./views/AttachmentFileManagement/List.vue";
import DetailAttachment from "./views/AttachmentFileManagement/Detail.vue";
import EditAttachment from "./views/AttachmentFileManagement/Edit.vue";
import SettingSeat from "./views/BusManagement/SettingSeat.vue";
import AttachmentFileUser from "./views/AttachmentFileManagement/AttachmentFileUser.vue";
import ParentSelectBus from "./views/PickupRoute/ParentSelectBus.vue";
import CancelList from "./views/Schedule/CancelList"
import CancelDetail from "./views/Schedule/CancelDetail"
import BusHistory from './views/BusManagement/History'
import DayOffList from "./views/DayOff/DayOffList"
import DayOffAdd from './views/DayOff/Add'
import DayOffDetail from './views/DayOff/Detail'
import DayOffEdit from './views/DayOff/Edit'
import DayOffCalendar from './views/DayOff/Calendar'
import StudentImport from '@/views/Student/Import'
import PlaceImport from '@/views/Place/Import'
import CancelAdd from '@/views/Schedule/CancelAdd'
import TemplateList from "./views/Schedule/TemplateList";
import AddTemplate from "./views/Schedule/AddTemplate";
import AuthorizedPersonNotificationList from "./views/Notification/AuthorizedPersonNotificationList";
import AuthorizedPersonNotificationDetail from "./views/Notification/AuthorizedPersonNotificationDetail";

import CategoryManagement from './views/CategoryManagement/index'
import FileManagement from './views/FileManagement/index'
import EditFile from './views/FileManagement/edit'
import EditFileCategory from "@/views/CategoryManagement/edit";
import DetailFileCategory from '@/views/CategoryManagement/detail'

import ParentNeedApprove from "@/views/ParentManagement/ParentNeedApprove";
import AddTemplatePickup from "@/views/Schedule/AddTemplatePickup";
import LogManagement from '@/views/LogManagement/index'

import ListStudentApprove from '@/views/Student/ListStudentWaitApprove'
import DetailStudentApprove from '@/views/Student/studentApproveDetail'
import ListNewStudentNotification from './views/Notification/NewStudentList'
Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/bus',
      name: 'bus',
      component: Bus
    }, {
      path: '/bus/add',
      name: 'add-bus',
      component: AddBus
    }, {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/account/delete',
      name: 'accountDelete',
      component: ConfirmAccount
    }
    , {
      path: '/bus/detail',
      name: 'detail-bus',
      component: DetailBus
    }, {
      path: '/bus/edit',
      name: 'edit-bus',
      component: EditBus
    }, {
      path: '/parent',
      name: 'parent-list',
      component: ParentList
    }, {
      path: '/parent/add',
      name: 'add-parent',
      component: AddParent
    }, {
      path: '/parent/detail',
      name: 'detail-parent',
      component: DetailParent
    },
    {
      path: '/parent/edit',
      name: 'edit-parent',
      component: EditParent
    },
    {
      path: '/driver/add',
      name: 'add-driver',
      component: AddDriver
    }, {
      path: '/sub-driver',
      name: 'list-sub-driver',
      component: ListSubDriver
    }, {
      path: '/sub-driver/add',
      name: 'add-sub-driver',
      component: AddSubDriver
    }, {
      path: '/sub-driver/detail',
      name: 'detail-sub-driver',
      component: DetailSubDriver
    }, {
      path: '/sub-driver/edit',
      name: 'edit-sub-driver',
      component: EditSubDriver
    }, {
      path: '/place/add',
      name: 'add-place',
      component: AddPlace
    }, {
      path: '/place',
      name: 'list-place',
      component: ListPlace
    }, {
      path: '/place/detail',
      name: 'detail-place',
      component: DetailPlace
    }, {
      path: '/place/edit',
      name: 'edit-place',
      component: EditPlace
    }, {
      path: '/student',
      name: 'list-student',
      component: ListStudent
    }, {
      path: '/student/detail',
      name: 'detail-student',
      component: DetailStudent
    }, {
      path: '/pickup-route/add',
      name: 'add-pickup-route',
      component: AddPickupRoute
    }, {
      path: '/pickup-route',
      name: 'list-pickup-route',
      component: ListPickupRoute
    }, {
      path: '/pickup-route/detail',
      name: 'detail-pickup-route',
      component: DetailPickupRoute
    }, {
      path: '/pickup-route/edit',
      name: 'edit-pickup-route',
      component: EditPickupRoute
    }, {
      path: '/drop-route/add',
      name: 'add-drop-route',
      component: AddDropRoute
    }, {
      path: '/drop-route',
      name: 'list-drop-route',
      component: ListDropRoute
    }, {
      path: '/drop-route/detail',
      name: 'detail-drop-route',
      component: DetailDropRoute
    }, {
      path: '/drop-route/edit',
      name: 'edit-drop-route',
      component: EditDropRoute
    },
    {
      path: '/classroom/add',
      name: 'add-class',
      component: AddClass
    }, {
      path: '/classroom',
      name: 'list-class',
      component: ListClass
    }, {
      path: '/classroom/detail',
      name: 'detail-class',
      component: DetailClass
    }, {
      path: '/classroom/edit',
      name: 'edit-class',
      component: EditClass
    }, {
      path: '/bus/layout/samco34',
      name: 'samco-34',
      component: Samco34
    }, {
      path: '/bus/layout/samco24',
      name: 'samco-24',
      component: Samco24
    }, {
      path: '/bus/layout/transit16',
      name: 'transit-16',
      component: Transit16
    }, {
      path: '/admin-notification-template/add',
      name: 'add-admin-notification-template',
      component: AddAdminNotificationTemplate
    }, {
      path: '/admin-notification-template',
      name: 'list-admin-notification-template',
      component: ListAdminNotificationTemplate
    }, {
      path: '/admin-notification-template/detail',
      name: 'detail-admin-notification-template',
      component: DetailAdminNotificationTemplate
    }, {
      path: '/admin-notification-template/edit',
      name: 'edit-admin-notification-template',
      component: EditAdminNotificationTemplate
    }, {
      path: '/parent-notification-template/add',
      name: 'add-parent-notification-template',
      component: AddParentNotificationTemplate
    }, {
      path: '/parent-notification-template',
      name: 'list-parent-notification-template',
      component: ListParentNotificationTemplate
    }, {
      path: '/parent-notification-template/detail',
      name: 'detail-parent-notification-template',
      component: DetailParentNotificationTemplate
    }, {
      path: '/parent-notification-template/edit',
      name: 'edit-parent-notification-template',
      component: EditParentNotificationTemplate
    }, {
      path: '/bus-notification-template/add-category',
      name: 'add-bus-notification-category',
      component: AddBusNotificationCategory
    }, {
      path: '/bus-notification-template/category',
      name: 'list-bus-notification-category',
      component: ListBusNotificationCategory
    }, {
      path: '/bus-notification-template/edit-category',
      name: 'edit-bus-notification-category',
      component: EditBusNotificationCategory
    }, {
      path: '/bus-notification-template/detail-category',
      name: 'detail-bus-notification-category',
      component: DetailBusNotificationCategory
    }, {
      path: '/bus-notification-template',
      name: 'list-bus-notification-template',
      component: ListBusNotificationTemplate
    }, {
      path: '/bus-notification-template/add',
      name: 'add-bus-notification-template',
      component: AddBusNotificationTemplate
    }, {
      path: '/bus-notification-template/detail',
      name: 'detail-bus-notification-template',
      component: DetailBusNotificationTemplate
    }, {
      path: '/bus-notification-template/edit',
      name: 'edit-bus-notification-template',
      component: EditBusNotificationTemplate
    }, {
      path: '/notification-group/add',
      name: 'admin-notification-group-add',
      component: AddAdminNotificationGroup
    }, {
      path: '/notification-group',
      name: 'admin-notification-group-list',
      component: ListAdminNotificationGroup
    }, {
      path: '/notification-group/detail',
      name: 'admin-notification-group-detail',
      component: DetailAdminNotificationGroup
    }, {
      path: '/notification-group/edit',
      name: 'admin-notification-group-edit',
      component: EditAdminNotificationGroup
    }, {
      path: '/notification/add',
      name: 'admin-notification-add',
      component: AddAdminNotification
    }, {
      path: '/admin-notification',
      name: 'admin-notification-list',
      component: ListAdminNotification
    }, {
      path: '/admin-notification/detail',
      name: 'admin-notification-detail',
      component: DetailAdminNotification
    }, {
      path: '/notification/bus',
      name: 'bus-notification-list',
      component: ListBusNotification
    }, {
      path: '/notification/bus/detail',
      name: 'bus-notification-detail',
      component: DetailBusNotification
    }, {
      path: '/schedule/detail',
      name: 'schedule-detail',
      component: ScheduleDetail
    }, {
      path: '/driver',
      name: 'driver-list',
      component: ListDriver
    }, {
      path: '/driver/detail',
      name: 'driver-detail',
      component: DetailDriver
    }, {
      path: '/driver/edit',
      name: 'driver-edit',
      component: EditDriver
    }, {
      path: '/setting-school',
      name: 'setting-school',
      component: SettingSchoolInfo
    }, {
      path: '/admin/add',
      name: 'add-admin',
      component: AddAdmin
    }, {
      path: '/admin',
      name: 'list-admin',
      component: ListAdmin
    }, {
      path: '/admin/detail',
      name: 'detail-admin',
      component: DetailAdmin
    }, {
      path: '/admin/edit',
      name: 'edit-admin',
      component: EditAdmin
    }, {
      path: '/attachment/add',
      name: 'add-attachment',
      component: AddAttachment
    }, {
      path: '/attachment',
      name: 'list-attachment',
      component: ListAttachment
    }, {
      path: '/attachment/detail',
      name: 'detail-attachment',
      component: DetailAttachment
    }, {
      path: '/attachment/edit',
      name: 'edit-attachment',
      component: EditAttachment
    }, {
      path: '/bus/setting-seat',
      name: 'setting-seat',
      component: SettingSeat
    }, {
      path: '/attachment/file-user',
      name: 'attachment-file-user',
      component: AttachmentFileUser
    }, {
      path: '/parent/select-bus',
      name: 'parent-select-bus',
      component: ParentSelectBus
    }, {
      path: '/notification/parent-update-profile',
      name: 'parent-update-profile-list',
      component: ParentUpdateProfileList
    }, {
      path: '/notification/parent-update-profile/detail',
      name: 'parent-update-profile-detail',
      component: ParentUpdateProfileDetail
    }, {
      path: '/notification/parent',
      name: 'parent-notification-list',
      component: ParentNotificationList
    }, {
      path: '/notification/parent/detail',
      name: 'parent-notification-detail',
      component: ParentNotificationDetail
    }, {
      path: '/schedule/cancel',
      name: 'cancel-list',
      component: CancelList
    }, {
      path: '/schedule/cancel/add',
      name: 'cancel-add',
      component: CancelAdd
    }, {
      path: '/schedule/cancel/detail',
      name: 'cancel-detail',
      component: CancelDetail
    }, {
      path: '/bus/history',
      name: 'bus-history',
      component: BusHistory
    }, {
      path: '/general/day-off',
      name: 'day-off',
      component: DayOffList
    }, {
      path: '/general/day-off/add',
      name: 'day-off-add',
      component: DayOffAdd
    }, {
      path: '/general/day-off/detail',
      name: 'day-off-detail',
      component: DayOffDetail
    }, {
      path: '/general/day-off/edit',
      name: 'day-off-edit',
      component: DayOffEdit
    }, {
      path: '/general/day-off/calendar',
      name: 'day-off-calendar',
      component: DayOffCalendar
    }, {
      path: '/student/import',
      name: 'student-import',
      component: StudentImport
    }, {
      path: '/place/import',
      name: 'place-import',
      component: PlaceImport
    }, {
      path: '/forgot',
      name: 'forgot',
      component: Forgot
    }, {
      path: '/schedule/template-list',
      name: 'template-list',
      component: TemplateList
    }, {
      path: '/schedule/add-template',
      name: 'add-template',
      component: AddTemplate
    }, {
      path: '/notification/authorized-person',
      name: 'authorized-person-notification-list',
      component: AuthorizedPersonNotificationList
    }, {
      path: '/notification/authorized-person/detail',
      name: 'authorized-person-notification-detail',
      component: AuthorizedPersonNotificationDetail
    },
    {
      path: '/category-management',
      name: 'category-management',
      component: CategoryManagement
    },
    {
      path: '/file-management',
      name: 'file-management',
      component: FileManagement
    },
    {
      path: '/category-management/:id',
      name: 'category-management-id',
      component: DetailFileCategory
    },
    {
      path: '/category-management-create',
      name: 'category-management-create',
      component: EditFileCategory
    },
    {
      path: '/category-management-edit',
      name: 'category-management-edit',
      component: EditFileCategory
    },
    {
      path: '/file-management-edit',
      name: 'file-management-edit',
      component: EditFile
    },
    {
      path: '/file-management-create',
      name: 'file-management-create',
      component: EditFile
    },
    {
      path: '/list-parent-need-approve',
      name: 'list-parent-need-approve',
      component: ParentNeedApprove
    },
    {
      path: '/schedule/add-template-pickup',
      name: 'schedule-add-template-pickup',
      component: AddTemplatePickup
    },
    {
      path: '/log-management',
      name: 'log-management',
      component:LogManagement
    },
    {
      path: '/student/list-wait-approve',
      name: 'student-list-wait-approve',
      component: ListStudentApprove
    },
    {
      path: '/student/detail-wait',
      name: 'student-detail-wait',
      component:DetailStudentApprove
    },
    {
      path: '/term-of-user',
      name: 'term-of-user',
      component:ListTermOfUser
    },
    {
      path: '/notification/new-student',
      name: 'notification-new-student',
      component:ListNewStudentNotification
    },
    {
      path: '/grade-management',
      name: 'grade-management',
      component:ListGrade
    },
    {
      path: '/grade-management/create',
      name: 'grade-management-create',
      component:CreateGrade
    },
    {
      path: '/grade-management/edit',
      name: 'grade-management-edit',
      component:EditGrade
    },
    {
      path: '/grade-management/:id',
      name: 'grade-management-id',
      component:DetailGrade
    },
  ]
})
